import React from 'react';

import { Button } from '@appcharge/shared-ui';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from 'components/ui/card';

interface ISettingsCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  hasHeaderSeparator?: boolean;
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isLoading?: boolean;
  saveButtonDataTestId?: string;
}

export const SettingsCard: React.FC<ISettingsCardProps> = ({
  title,
  description,
  children,
  hasHeaderSeparator,
  onSave,
  isSaveDisabled,
  isLoading,
  saveButtonDataTestId
}) => (
  <Card className="w-full border border-base-muted-foreground shadow-none">
    <CardHeader
      className={`flex flex-row items-start justify-between space-y-0 ${hasHeaderSeparator ? 'pb-6' : 'pb-4'}`}
    >
      <div className="flex flex-col gap-1">
        <CardTitle className="text-base font-semibold text-gray-900">
          {title}
        </CardTitle>
        {description && (
          <CardDescription className="text-sm text-gray-500">
            {description}
          </CardDescription>
        )}
      </div>
      {onSave && (
        <Button
          variant="default"
          onClick={onSave}
          disabled={isSaveDisabled}
          isLoading={isLoading}
          className="h-9 min-w-[80px] rounded-lg bg-gray-900 px-4 font-medium text-white hover:bg-gray-800 disabled:bg-gray-400"
          data-testid={saveButtonDataTestId}
        >
          Save
        </Button>
      )}
    </CardHeader>
    {hasHeaderSeparator && <div className="h-px w-full bg-base-border" />}
    <CardContent className={hasHeaderSeparator ? 'pt-8' : undefined}>
      {children}
    </CardContent>
  </Card>
);
